import { useState, useCallback } from "react";

// ── VEHICLE DATA ──────────────────────────────────────────────────────────────
const VEHICLE_DATA = {
  "Acura":      ["ILX","Integra","MDX","RDX","TLX","ZDX"],
  "Audi":       ["A3","A4","A5","A6","A7","A8","e-tron","Q3","Q5","Q7","Q8","TT"],
  "BMW":        ["2 Series","3 Series","4 Series","5 Series","7 Series","8 Series","i4","iX","X1","X2","X3","X4","X5","X6","X7","Z4"],
  "Buick":      ["Enclave","Encore","Encore GX","Envision","LaCrosse"],
  "Cadillac":   ["CT4","CT5","Escalade","LYRIQ","XT4","XT5","XT6"],
  "Chevrolet":  ["Blazer","Bolt EV","Colorado","Corvette","Equinox","Express","Impala","Malibu","Silverado 1500","Silverado 2500HD","Suburban","Tahoe","Traverse","Trax"],
  "Chrysler":   ["300","Pacifica","Voyager"],
  "Dodge":      ["Challenger","Charger","Durango","Grand Caravan","Hornet"],
  "Ford":       ["Bronco","Bronco Sport","Edge","Escape","Explorer","F-150","F-250","F-350","Maverick","Mustang","Mustang Mach-E","Ranger","Transit"],
  "GMC":        ["Acadia","Canyon","Sierra 1500","Sierra 2500HD","Terrain","Yukon"],
  "Honda":      ["Accord","Civic","CR-V","HR-V","Odyssey","Passport","Pilot","Ridgeline"],
  "Hyundai":    ["Elantra","IONIQ 5","IONIQ 6","Kona","Palisade","Santa Cruz","Santa Fe","Sonata","Tucson","Venue"],
  "Infiniti":   ["Q50","Q60","QX50","QX55","QX60","QX80"],
  "Jaguar":     ["E-PACE","F-PACE","F-TYPE","I-PACE","XE","XF"],
  "Jeep":       ["Cherokee","Compass","Gladiator","Grand Cherokee","Grand Cherokee L","Renegade","Wrangler"],
  "Kia":        ["Carnival","EV6","Forte","K5","Niro","Seltos","Sorento","Soul","Sportage","Stinger","Telluride"],
  "Land Rover": ["Defender","Discovery","Discovery Sport","Range Rover","Range Rover Evoque","Range Rover Sport","Range Rover Velar"],
  "Lexus":      ["ES","GS","GX","IS","LC","LS","LX","NX","RX","UX"],
  "Lincoln":    ["Aviator","Corsair","Nautilus","Navigator"],
  "Mazda":      ["CX-30","CX-5","CX-50","CX-90","Mazda3","Mazda6","MX-5 Miata"],
  "Mercedes-Benz": ["A-Class","C-Class","CLA","CLE","E-Class","EQB","EQE","EQS","G-Class","GLA","GLB","GLC","GLE","GLS","S-Class"],
  "Mitsubishi": ["Eclipse Cross","Outlander","Outlander Sport"],
  "Nissan":     ["Altima","Armada","Frontier","Kicks","Leaf","Maxima","Murano","Pathfinder","Rogue","Sentra","Titan","Versa"],
  "Ram":        ["1500","2500","3500","ProMaster"],
  "Rivian":     ["R1S","R1T"],
  "Subaru":     ["Ascent","BRZ","Crosstrek","Forester","Impreza","Legacy","Outback","Solterra","WRX"],
  "Tesla":      ["Cybertruck","Model 3","Model S","Model X","Model Y"],
  "Toyota":     ["4Runner","Avalon","bZ4X","Camry","Corolla","Crown","GR86","Highlander","Land Cruiser","Prius","RAV4","Sequoia","Sienna","Tacoma","Tundra","Venza"],
  "Volkswagen": ["Atlas","Golf","ID.4","Jetta","Passat","Taos","Tiguan"],
  "Volvo":      ["C40","S60","S90","V60","XC40","XC60","XC90"],
};

const VEHICLE_MAKES = Object.keys(VEHICLE_DATA).sort();
const VEHICLE_YEARS = Array.from({length: 31}, (_, i) => String(2025 - i));



// ── STREAMING DATA (hardcoded, updated monthly) ───────────────────────────────
const STREAMING_PLANS = [
  { provider: "Netflix", color: "#e50914", plans: [
    { name: "Standard with Ads", price: 7.99, quality: "1080p", screens: 2, downloads: false },
    { name: "Standard", price: 15.49, quality: "1080p", screens: 2, downloads: true },
    { name: "Premium", price: 22.99, quality: "4K Ultra HD", screens: 4, downloads: true },
  ]},
  { provider: "Disney+", color: "#006e99", plans: [
    { name: "Basic (with Ads)", price: 7.99, quality: "1080p", screens: 4, downloads: false },
    { name: "Premium", price: 13.99, quality: "4K Ultra HD", screens: 4, downloads: true },
  ]},
  { provider: "Hulu", color: "#1ce783", plans: [
    { name: "With Ads", price: 7.99, quality: "1080p", screens: 2, downloads: false },
    { name: "No Ads", price: 17.99, quality: "1080p", screens: 2, downloads: true },
  ]},
  { provider: "Apple TV+", color: "#555", plans: [
    { name: "Apple TV+", price: 9.99, quality: "4K HDR", screens: 6, downloads: true },
  ]},
  { provider: "Max (HBO)", color: "#002be7", plans: [
    { name: "With Ads", price: 9.99, quality: "1080p", screens: 2, downloads: false },
    { name: "Ad-Free", price: 15.99, quality: "4K Ultra HD", screens: 3, downloads: true },
    { name: "Ultimate", price: 19.99, quality: "4K Ultra HD", screens: 4, downloads: true },
  ]},
  { provider: "Peacock", color: "#f0a500", plans: [
    { name: "Free", price: 0, quality: "1080p", screens: 3, downloads: false },
    { name: "Premium", price: 7.99, quality: "1080p", screens: 3, downloads: false },
    { name: "Premium Plus", price: 13.99, quality: "1080p", screens: 3, downloads: true },
  ]},
  { provider: "Paramount+", color: "#0064ff", plans: [
    { name: "Essential", price: 7.99, quality: "1080p", screens: 3, downloads: false },
    { name: "With SHOWTIME", price: 12.99, quality: "4K", screens: 3, downloads: true },
  ]},
  { provider: "Amazon Prime Video", color: "#00a8e0", plans: [
    { name: "With Ads", price: 8.99, quality: "4K Ultra HD", screens: 3, downloads: true },
    { name: "Prime (no ads)", price: 14.99, quality: "4K Ultra HD", screens: 3, downloads: true },
  ]},
];

const STREAMING_BUNDLES = [
  { name: "Disney Bundle (Disney+, Hulu, ESPN+)", price: 14.99, savings: 6, url: "https://www.disneyplus.com/welcome/disney-hulu-espn" },
  { name: "Disney Bundle Premium (no ads)", price: 24.99, savings: 8, url: "https://www.disneyplus.com/welcome/disney-hulu-espn" },
  { name: "Apple One Individual", price: 21.95, savings: 6, includes: "TV+, Music, Arcade, iCloud+", url: "https://www.apple.com/apple-one/" },
];

// ── PROVIDER URL LOOKUP ───────────────────────────────────────────────────────
function getProviderUrl(provider) {
  const p = (provider || "").toLowerCase();
  if (p.includes("xfinity") || p.includes("comcast")) return "https://www.xfinity.com/learn/internet-service";
  if (p.includes("at&t") || p.includes("att"))        return "https://www.att.com/internet/";
  if (p.includes("t-mobile") || p.includes("tmobile"))return "https://www.t-mobile.com/home-internet";
  if (p.includes("verizon"))   return "https://www.verizon.com/home/internet/";
  if (p.includes("spectrum"))  return "https://www.spectrum.com/internet";
  if (p.includes("cox"))       return "https://www.cox.com/residential/internet.html";
  if (p.includes("frontier"))  return "https://frontier.com/local/internet";
  if (p.includes("mediacom"))  return "https://mediacomcable.com/internet/";
  if (p.includes("wow") || p.includes("wideopenwest")) return "https://www.wowinc.com/";
  if (p.includes("optimum"))   return "https://www.optimum.com/internet";
  if (p.includes("starlink"))  return "https://www.starlink.com/";
  if (p.includes("hughesnet")) return "https://www.hughesnet.com/";
  if (p.includes("viasat"))    return "https://www.viasat.com/home-internet/";
  return `https://www.google.com/search?q=${encodeURIComponent(provider + " internet service signup")}`;
}

function getMobileUrl(carrier) {
  const c = (carrier || "").toLowerCase();
  if (c.includes("t-mobile") || c.includes("tmobile")) return "https://www.t-mobile.com/cell-phone-plans";
  if (c.includes("verizon"))   return "https://www.verizon.com/plans/";
  if (c.includes("at&t") || c.includes("att")) return "https://www.att.com/plans/unlimited-data-plans/";
  if (c.includes("mint"))      return "https://www.mintmobile.com/plans/";
  if (c.includes("visible"))   return "https://www.visible.com/plans";
  if (c.includes("cricket"))   return "https://www.cricketwireless.com/cell-phone-plans";
  if (c.includes("metro"))     return "https://www.metrobyt-mobile.com/plans";
  if (c.includes("boost"))     return "https://www.boostmobile.com/plans/";
  if (c.includes("us mobile")) return "https://www.usmobile.com/plans";
  return `https://www.google.com/search?q=${encodeURIComponent(carrier + " cell phone plans")}`;
}

function getInsuranceUrl(provider) {
  const p = (provider || "").toLowerCase();
  if (p.includes("state farm"))   return "https://www.statefarm.com/";
  if (p.includes("geico"))        return "https://www.geico.com/";
  if (p.includes("progressive"))  return "https://www.progressive.com/";
  if (p.includes("allstate"))     return "https://www.allstate.com/";
  if (p.includes("usaa"))         return "https://www.usaa.com/inet/wc/insurance";
  if (p.includes("farmers"))      return "https://www.farmers.com/";
  if (p.includes("nationwide"))   return "https://www.nationwide.com/";
  if (p.includes("liberty"))      return "https://www.libertymutual.com/";
  if (p.includes("travelers"))    return "https://www.travelers.com/";
  if (p.includes("lemonade"))     return "https://www.lemonade.com/";
  if (p.includes("amica"))        return "https://www.amica.com/";
  return `https://www.google.com/search?q=${encodeURIComponent(provider + " insurance quote")}`;
}

// ── AI PROMPTS ────────────────────────────────────────────────────────────────
function internetPrompt(zip, city, speed) {
  return `Return ONLY raw JSON for 5 internet providers available near ${city ? city + " (" + zip + ")" : "zip code " + zip}.
User needs at least ${speed} Mbps download speed.
Schema: {"results":[{"provider":"","plan_name":"","download_speed":0,"upload_speed":0,"price_per_month":0,"intro_price":0,"intro_months":0,"contract_required":false,"contract_months":0,"unlimited_data":true,"data_cap_gb":0,"technology":"Cable","equipment_fee":0,"installation_fee":0,"deal_score":"good","deal_label":"","highlights":[]}]}
Rules:
- Only include ISPs that ACTUALLY serve ${city || zip} area (Xfinity/Comcast, AT&T, Spectrum, T-Mobile Home Internet, Verizon Fios, Cox, Frontier, Mediacom, WideOpenWest, etc.)
- Realistic prices for this market
- deal_score: "best" for lowest, "good" for middle, "fair" for higher
- technology: Cable / Fiber / DSL / Fixed Wireless / Satellite
- highlights: 2-3 key selling points like "No contract", "Symmetrical speeds", "Price lock guarantee"`;
}

function mobilePrompt(lines, dataNeeded, city) {
  return `Return ONLY raw JSON for 5 mobile carrier plans for ${lines} line${lines > 1 ? "s" : ""}${city ? " in " + city : ""}.
User needs ${dataNeeded} data per line.
Schema: {"results":[{"carrier":"","plan_name":"","price_per_month":0,"price_per_line":0,"data_per_line":"","hotspot":"","international":false,"network":"","deal_score":"good","deal_label":"","highlights":[],"perks":[]}]}
Rules:
- Use REAL carriers: T-Mobile, Verizon, AT&T, Mint Mobile, Visible, Cricket, Metro by T-Mobile, Boost, US Mobile
- Mix big carriers AND budget MVNOs for price comparison
- price_per_month = total for all ${lines} lines
- deal_score: "best" for lowest total, "good" for middle, "fair" for higher
- perks: included extras like ["Netflix included", "Apple TV+ included", "15GB hotspot"]
- highlights: 2-3 key points`;
}

function insurancePrompt(type, zip, city, details) {
  return `Return ONLY raw JSON for 5 ${type} insurance providers for ${city ? city + " (" + zip + ")" : "zip " + zip}. ${details}
Schema: {"results":[{"provider":"","plan_name":"","price_per_month":0,"coverage_summary":"","deductible":0,"am_best_rating":"A","customer_satisfaction":4.2,"deal_score":"good","deal_label":"","highlights":[],"coverage_features":[]}]}
Rules:
- Use REAL insurance companies that serve this area
- Realistic monthly premiums for ${city || zip}
- am_best_rating: A++, A+, A, A-, B+
- customer_satisfaction: 3.5 to 5.0
- deal_score: "best" for lowest, "good" for middle, "fair" for higher
- These are ESTIMATES only — real quotes require personal information`;
}

// ── API CALL ──────────────────────────────────────────────────────────────────
async function callAgent(prompt) {
  const resp = await fetch("/api/anthropic", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      model: "claude-haiku-4-5-20251001",
      max_tokens: 4000,
      messages: [{ role: "user", content: prompt }],
    }),
  });
  if (!resp.ok) throw new Error(`API error ${resp.status}`);
  const data = await resp.json();
  const text = data.content?.find(b => b.type === "text")?.text || "";
  const f = text.indexOf("{"), l = text.lastIndexOf("}");
  if (f === -1) throw new Error("No JSON in response");
  return JSON.parse(text.slice(f, l + 1));
}

// ── REVERSE GEOCODE zip from coords ──────────────────────────────────────────
async function getCityFromCoords(lat, lng) {
  try {
    const resp = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`);
    const data = await resp.json();
    const zip  = data.address?.postcode?.slice(0, 5) || "";
    const city = data.address?.city || data.address?.town || data.address?.village || "";
    const state = data.address?.state || "";
    return { zip, city, state, display: city && state ? `${city}, ${state}` : zip };
  } catch { return null; }
}

// ── UI HELPERS ────────────────────────────────────────────────────────────────
function DealBadge({ score, label }) {
  const c = { best: ["#f0fdf4","#bbf7d0","#15803d"], good: ["#eff6ff","#bfdbfe","#1d4ed8"], fair: ["#fffbeb","#fde68a","#b45309"] }[score] || ["#f8fafc","#e2e8f0","#6b7280"];
  return <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: c[0], border: `1.5px solid ${c[1]}`, color: c[2] }}>{label || score}</span>;
}

function AffiliateBtn({ url, label }) {
  if (!url) return null;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}
      style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "8px 16px", borderRadius: 8, background: "#1d4ed8", color: "#fff", fontSize: 13, fontWeight: 700, textDecoration: "none" }}
      onMouseEnter={e => e.currentTarget.style.background = "#1e40af"}
      onMouseLeave={e => e.currentTarget.style.background = "#1d4ed8"}>
      {label} →
    </a>
  );
}

// ── LOCATION INPUT WITH GEOLOCATION ──────────────────────────────────────────
function LocationInput({ zip, city, onZipChange, onLocationDetected }) {
  const [detecting, setDetecting] = useState(false);

  const detectLocation = useCallback(async () => {
    if (!navigator.geolocation) return;
    setDetecting(true);
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const result = await getCityFromCoords(pos.coords.latitude, pos.coords.longitude);
        if (result) onLocationDetected(result);
        setDetecting(false);
      },
      () => setDetecting(false),
      { timeout: 8000 }
    );
  }, [onLocationDetected]);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <label style={{ fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block", textTransform: "uppercase", letterSpacing: 0.5 }}>
        Your location
      </label>
      <div style={{ display: "flex", gap: 8 }}>
        <input
          value={city ? `${city} (${zip})` : zip}
          onChange={e => {
            const v = e.target.value.replace(/[^0-9]/g, "").slice(0, 5);
            onZipChange(v);
          }}
          placeholder="Enter zip code"
          style={{ flex: 1, padding: "10px 12px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, outline: "none", background: "#fff" }}
        />
        <button onClick={detectLocation} disabled={detecting} title="Use my location"
          style={{ padding: "10px 14px", borderRadius: 10, border: "1.5px solid #e5e7eb", background: detecting ? "#f1f5f9" : "#fff", cursor: detecting ? "not-allowed" : "pointer", fontSize: 16 }}>
          {detecting ? "⏳" : "📍"}
        </button>
      </div>
      {city && <div style={{ fontSize: 11, color: "#16a34a", marginTop: 4 }}>✓ Location detected: {city}</div>}
    </div>
  );
}

// ── RESULT CARDS ──────────────────────────────────────────────────────────────
function InternetCard({ r, rank }) {
  const [open, setOpen] = useState(false);
  const isTop = rank === 0;
  const techColor = { Fiber: "#7c3aed", Cable: "#0369a1", "Fixed Wireless": "#0891b2", DSL: "#6b7280", Satellite: "#d97706" }[r.technology] || "#6b7280";
  return (
    <div onClick={() => setOpen(o => !o)} style={{ background: "#fff", borderRadius: 14, marginBottom: 10, overflow: "hidden", cursor: "pointer", border: `1.5px solid ${open ? "#2563eb" : isTop ? "#bfdbfe" : "#e5e7eb"}`, boxShadow: isTop ? "0 2px 12px rgba(37,99,235,0.08)" : "0 1px 3px rgba(0,0,0,0.04)" }}>
      {isTop && <div style={{ background: "#eff6ff", borderBottom: "1px solid #bfdbfe", padding: "5px 18px", display: "flex", alignItems: "center", gap: 6 }}><div style={{ width: 6, height: 6, borderRadius: "50%", background: "#2563eb" }} /><span style={{ fontSize: 11, fontWeight: 600, color: "#1d4ed8" }}>Best deal in your area</span></div>}
      <div style={{ padding: "16px 18px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6, flexWrap: "wrap" }}>
              <span style={{ fontSize: 15, fontWeight: 700 }}>{r.provider}</span>
              <span style={{ fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 12, background: `${techColor}18`, color: techColor, border: `1px solid ${techColor}30` }}>{r.technology}</span>
              <DealBadge score={r.deal_score} label={r.deal_label} />
            </div>
            <div style={{ fontSize: 13, color: "#374151", marginBottom: 6 }}>{r.plan_name}</div>
            <div style={{ display: "flex", gap: 14, fontSize: 12, color: "#6b7280", flexWrap: "wrap" }}>
              <span>⬇ {r.download_speed} Mbps</span>
              <span>⬆ {r.upload_speed} Mbps</span>
              <span>{r.unlimited_data ? "Unlimited data" : `${r.data_cap_gb}GB cap`}</span>
            </div>
          </div>
          <div style={{ textAlign: "right", flexShrink: 0 }}>
            {r.intro_price > 0 && r.intro_months > 0 ? <>
              <div style={{ fontSize: 22, fontWeight: 900, letterSpacing: -1, color: "#15803d" }}>${r.intro_price}<span style={{ fontSize: 12, fontWeight: 400, color: "#6b7280" }}>/mo</span></div>
              <div style={{ fontSize: 11, color: "#6b7280" }}>for {r.intro_months} mo, then ${r.price_per_month}/mo</div>
            </> : <div style={{ fontSize: 22, fontWeight: 900, letterSpacing: -1 }}>${r.price_per_month}<span style={{ fontSize: 12, fontWeight: 400, color: "#6b7280" }}>/mo</span></div>}
            <div style={{ fontSize: 11, marginTop: 2, color: r.contract_required ? "#f59e0b" : "#16a34a" }}>{r.contract_required ? `${r.contract_months}-mo contract` : "No contract"}</div>
          </div>
        </div>
        {open && <div style={{ marginTop: 14, paddingTop: 14, borderTop: "1px solid #f1f5f9" }}>
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 10 }}>
            {r.equipment_fee > 0 && <div><div style={{ fontSize: 11, color: "#9ca3af" }}>Equipment</div><div style={{ fontSize: 13, fontWeight: 600 }}>+${r.equipment_fee}/mo</div></div>}
            {r.installation_fee > 0 && <div><div style={{ fontSize: 11, color: "#9ca3af" }}>Installation</div><div style={{ fontSize: 13, fontWeight: 600 }}>+${r.installation_fee} one-time</div></div>}
          </div>
          {r.highlights?.length > 0 && <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 12 }}>{r.highlights.map((h, i) => <span key={i} style={{ fontSize: 12, padding: "3px 10px", background: "#f8fafc", border: "1px solid #e5e7eb", borderRadius: 20 }}>{h}</span>)}</div>}
          <AffiliateBtn url={getProviderUrl(r.provider)} label="Check availability" />
        </div>}
      </div>
    </div>
  );
}

function MobileCard({ r, rank }) {
  const [open, setOpen] = useState(false);
  const isTop = rank === 0;
  return (
    <div onClick={() => setOpen(o => !o)} style={{ background: "#fff", borderRadius: 14, marginBottom: 10, overflow: "hidden", cursor: "pointer", border: `1.5px solid ${open ? "#2563eb" : isTop ? "#bfdbfe" : "#e5e7eb"}`, boxShadow: isTop ? "0 2px 12px rgba(37,99,235,0.08)" : "0 1px 3px rgba(0,0,0,0.04)" }}>
      {isTop && <div style={{ background: "#eff6ff", borderBottom: "1px solid #bfdbfe", padding: "5px 18px", display: "flex", alignItems: "center", gap: 6 }}><div style={{ width: 6, height: 6, borderRadius: "50%", background: "#2563eb" }} /><span style={{ fontSize: 11, fontWeight: 600, color: "#1d4ed8" }}>Best deal for your needs</span></div>}
      <div style={{ padding: "16px 18px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6, flexWrap: "wrap" }}>
              <span style={{ fontSize: 15, fontWeight: 700 }}>{r.carrier}</span>
              <DealBadge score={r.deal_score} label={r.deal_label} />
            </div>
            <div style={{ fontSize: 13, color: "#374151", marginBottom: 6 }}>{r.plan_name}</div>
            <div style={{ display: "flex", gap: 12, fontSize: 12, color: "#6b7280", flexWrap: "wrap" }}>
              <span>📶 {r.network}</span>
              <span>📱 {r.data_per_line}/line</span>
              {r.hotspot && <span>🔗 {r.hotspot} hotspot</span>}
              {r.international && <span>🌍 International</span>}
            </div>
          </div>
          <div style={{ textAlign: "right", flexShrink: 0 }}>
            <div style={{ fontSize: 22, fontWeight: 900, letterSpacing: -1 }}>${r.price_per_month}<span style={{ fontSize: 12, fontWeight: 400, color: "#6b7280" }}>/mo</span></div>
            <div style={{ fontSize: 12, color: "#6b7280" }}>${r.price_per_line}/line</div>
          </div>
        </div>
        {open && <div style={{ marginTop: 14, paddingTop: 14, borderTop: "1px solid #f1f5f9" }}>
          {r.perks?.length > 0 && <div style={{ marginBottom: 10 }}><div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 4 }}>Included perks</div><div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>{r.perks.map((p, i) => <span key={i} style={{ fontSize: 12, padding: "3px 10px", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 20, color: "#15803d" }}>✓ {p}</span>)}</div></div>}
          {r.highlights?.length > 0 && <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 12 }}>{r.highlights.map((h, i) => <span key={i} style={{ fontSize: 12, padding: "3px 10px", background: "#f8fafc", border: "1px solid #e5e7eb", borderRadius: 20 }}>{h}</span>)}</div>}
          <AffiliateBtn url={getMobileUrl(r.carrier)} label="View plan" />
        </div>}
      </div>
    </div>
  );
}

function InsuranceCard({ r, rank }) {
  const [open, setOpen] = useState(false);
  const isTop = rank === 0;
  return (
    <div onClick={() => setOpen(o => !o)} style={{ background: "#fff", borderRadius: 14, marginBottom: 10, overflow: "hidden", cursor: "pointer", border: `1.5px solid ${open ? "#2563eb" : isTop ? "#bfdbfe" : "#e5e7eb"}`, boxShadow: isTop ? "0 2px 12px rgba(37,99,235,0.08)" : "0 1px 3px rgba(0,0,0,0.04)" }}>
      {isTop && <div style={{ background: "#eff6ff", borderBottom: "1px solid #bfdbfe", padding: "5px 18px", display: "flex", alignItems: "center", gap: 6 }}><div style={{ width: 6, height: 6, borderRadius: "50%", background: "#2563eb" }} /><span style={{ fontSize: 11, fontWeight: 600, color: "#1d4ed8" }}>Best estimated rate</span></div>}
      <div style={{ padding: "16px 18px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6, flexWrap: "wrap" }}>
              <span style={{ fontSize: 15, fontWeight: 700 }}>{r.provider}</span>
              <span style={{ fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 12, background: "#f0fdf4", color: "#15803d", border: "1px solid #bbf7d0" }}>AM Best: {r.am_best_rating}</span>
              <DealBadge score={r.deal_score} label={r.deal_label} />
            </div>
            <div style={{ fontSize: 13, color: "#374151", marginBottom: 4 }}>{r.plan_name}</div>
            <div style={{ fontSize: 12, color: "#6b7280" }}>{r.coverage_summary}</div>
          </div>
          <div style={{ textAlign: "right", flexShrink: 0 }}>
            <div style={{ fontSize: 22, fontWeight: 900, letterSpacing: -1 }}>${r.price_per_month}<span style={{ fontSize: 12, fontWeight: 400, color: "#6b7280" }}>/mo</span></div>
            {r.deductible > 0 && <div style={{ fontSize: 12, color: "#6b7280" }}>${r.deductible?.toLocaleString()} deductible</div>}
            <div style={{ display: "flex", alignItems: "center", gap: 4, justifyContent: "flex-end", marginTop: 2 }}><span style={{ color: "#f59e0b" }}>★</span><span style={{ fontSize: 12, fontWeight: 600 }}>{r.customer_satisfaction}/5</span></div>
          </div>
        </div>
        {open && <div style={{ marginTop: 14, paddingTop: 14, borderTop: "1px solid #f1f5f9" }}>
          {r.coverage_features?.length > 0 && <div style={{ marginBottom: 10 }}><div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 6 }}>Coverage includes</div><div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>{r.coverage_features.map((f, i) => <span key={i} style={{ fontSize: 12, padding: "3px 10px", background: "#f8fafc", border: "1px solid #e5e7eb", borderRadius: 20 }}>✓ {f}</span>)}</div></div>}
          <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, padding: "10px 12px", marginBottom: 12, fontSize: 12, color: "#92400e" }}>⚠️ Estimates only. Actual rates depend on your personal details, history, and coverage choices.</div>
          <AffiliateBtn url={getInsuranceUrl(r.provider)} label="Get a free quote" />
        </div>}
      </div>
    </div>
  );
}

// ── STREAMING SECTION ─────────────────────────────────────────────────────────
function StreamingSection() {
  const [selected, setSelected] = useState([]);
  const [showBundles, setShowBundles] = useState(false);
  const total = selected.reduce((sum, key) => {
    const [pIdx, plIdx] = key.split("-").map(Number);
    return sum + (STREAMING_PLANS[pIdx]?.plans[plIdx]?.price || 0);
  }, 0);
  const toggle = (key) => setSelected(s => s.includes(key) ? s.filter(k => k !== key) : [...s, key]);
  return (
    <div>
      <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 16 }}>Select your current streaming subscriptions to see your total monthly spend and find bundle savings.</div>
      {STREAMING_PLANS.map((p, pIdx) => (
        <div key={p.provider} style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: "#374151", marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.5 }}>{p.provider}</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {p.plans.map((plan, plIdx) => {
              const key = `${pIdx}-${plIdx}`;
              const sel = selected.includes(key);
              return (
                <button key={key} onClick={() => toggle(key)} style={{ padding: "8px 14px", borderRadius: 10, border: `2px solid ${sel ? p.color : "#e5e7eb"}`, background: sel ? `${p.color}18` : "#fff", cursor: "pointer", textAlign: "left" }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: sel ? p.color : "#374151" }}>{plan.name}</div>
                  <div style={{ fontSize: 14, fontWeight: 800, color: sel ? p.color : "#111" }}>{plan.price === 0 ? "Free" : `$${plan.price}/mo`}</div>
                  <div style={{ fontSize: 10, color: "#9ca3af" }}>{plan.quality} · {plan.screens} screens{plan.downloads ? " · Downloads" : ""}</div>
                </button>
              );
            })}
          </div>
        </div>
      ))}
      {selected.length > 0 && (
        <div style={{ marginTop: 20, background: "#1d4ed8", borderRadius: 14, padding: "20px 24px", color: "#fff" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: showBundles ? 16 : 0 }}>
            <div>
              <div style={{ fontSize: 13, opacity: 0.8 }}>{selected.length} service{selected.length > 1 ? "s" : ""} selected</div>
              <div style={{ fontSize: 30, fontWeight: 900, letterSpacing: -1 }}>${total.toFixed(2)}<span style={{ fontSize: 15, fontWeight: 400, opacity: 0.8 }}>/month</span></div>
              <div style={{ fontSize: 13, opacity: 0.7 }}>${(total * 12).toFixed(0)}/year</div>
            </div>
            <button onClick={() => setShowBundles(b => !b)} style={{ padding: "10px 18px", borderRadius: 10, border: "2px solid rgba(255,255,255,0.4)", background: "rgba(255,255,255,0.15)", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
              {showBundles ? "Hide bundles" : "💡 Find savings"}
            </button>
          </div>
          {showBundles && (
            <div>
              <div style={{ fontSize: 11, opacity: 0.6, marginBottom: 8, textTransform: "uppercase", letterSpacing: 0.5 }}>Bundle deals</div>
              {STREAMING_BUNDLES.map((b, i) => (
                <div key={i} style={{ background: "rgba(255,255,255,0.12)", borderRadius: 10, padding: "12px 14px", marginBottom: 8, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600 }}>{b.name}</div>
                    {b.includes && <div style={{ fontSize: 11, opacity: 0.7 }}>Includes {b.includes}</div>}
                    <div style={{ fontSize: 11, color: "#86efac" }}>Save ~${b.savings}/mo vs individual</div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ fontSize: 18, fontWeight: 800 }}>${b.price}/mo</div>
                    <a href={b.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: 11, color: "#bfdbfe", textDecoration: "underline" }}>Learn more →</a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ── MAIN COMPONENT ────────────────────────────────────────────────────────────
const CATEGORIES    = [
  { key: "internet",  label: "Internet",  icon: "🌐" },
  { key: "mobile",    label: "Mobile",    icon: "📱" },
  { key: "insurance", label: "Insurance", icon: "🛡️" },
  { key: "streaming", label: "Streaming", icon: "📺" },
];
const INSURANCE_TYPES = ["Auto", "Home", "Life", "Renters"];
const DATA_OPTIONS    = ["1GB", "5GB", "10GB", "Unlimited"];
const SPEED_OPTIONS   = [25, 50, 100, 200, 500, 1000];
const inp = { width: "100%", padding: "10px 12px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, outline: "none", boxSizing: "border-box", background: "#fff" };
const lbl = { fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block", textTransform: "uppercase", letterSpacing: 0.5 };
const fld = { display: "flex", flexDirection: "column" };

export default function BillsSearch() {
  const [cat, setCat]         = useState("internet");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError]     = useState(null);

  // Shared location state
  const [zip, setZip]         = useState("");
  const [city, setCity]       = useState("");

  // Internet
  const [speed, setSpeed]     = useState(100);

  // Mobile
  const [lines, setLines]     = useState(1);
  const [data, setData]       = useState("Unlimited");

  // Insurance
  const [insType, setInsType]   = useState("Auto");
  // Auto insurance fields
  const [carYear, setCarYear]   = useState("");
  const [carMake, setCarMake]   = useState("");
  const [carModel, setCarModel] = useState("");
  // Home insurance fields
  const [homeSqft, setHomeSqft] = useState("");
  const [homeYear, setHomeYear] = useState("");
  // Life/Renters fields
  const [personAge, setPersonAge] = useState("");
  const [smoker, setSmoker]     = useState("No");

  const handleLocationDetected = useCallback(({ zip: z, city: c }) => {
    setZip(z || "");
    setCity(c || "");
  }, []);

  const search = async () => {
    setLoading(true); setError(null); setResults(null);
    try {
      let prompt;
      if (cat === "internet") {
        if (!zip) throw new Error("Please enter your zip code or use location detection");
        prompt = internetPrompt(zip, city, speed);
      } else if (cat === "mobile") {
        prompt = mobilePrompt(lines, data, city);
      } else {
        if (!zip) throw new Error("Please enter your zip code or use location detection");
        let insDetails = "";
        if (insType === "Auto") {
          if (carYear || carMake || carModel) insDetails = `Vehicle: ${carYear} ${carMake} ${carModel}`.trim();
        } else if (insType === "Home") {
          if (homeSqft || homeYear) insDetails = `Home: ${homeSqft ? homeSqft + " sq ft" : ""} ${homeYear ? "built " + homeYear : ""}`.trim();
        } else {
          if (personAge || smoker) insDetails = `${personAge ? "Age: " + personAge : ""} ${smoker === "Yes" ? "Smoker" : "Non-smoker"}`.trim();
        }
        prompt = insurancePrompt(insType, zip, city, insDetails);
      }
      const res = await callAgent(prompt);
      if (!res.results?.length) throw new Error("No results found. Try adjusting your search.");
      setResults(res.results);
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 16px 40px", fontFamily: "system-ui, -apple-system, sans-serif" }}>

      {/* Tabs */}
      <div style={{ display: "flex", gap: 6, marginBottom: 20, background: "#f8fafc", borderRadius: 12, padding: 4 }}>
        {CATEGORIES.map(c => (
          <button key={c.key} onClick={() => { setCat(c.key); setResults(null); setError(null); }} style={{ flex: 1, padding: "10px 4px", borderRadius: 9, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 600, background: cat === c.key ? "#fff" : "transparent", color: cat === c.key ? "#1d4ed8" : "#6b7280", boxShadow: cat === c.key ? "0 1px 4px rgba(0,0,0,0.08)" : "none", transition: "all 0.15s" }}>
            {c.icon} {c.label}
          </button>
        ))}
      </div>

      {/* Streaming — no form */}
      {cat === "streaming" && (
        <div style={{ background: "#fff", borderRadius: 16, border: "1.5px solid #e5e7eb", padding: 20, boxShadow: "0 1px 6px rgba(0,0,0,0.04)" }}>
          <StreamingSection />
        </div>
      )}

      {/* Search form */}
      {cat !== "streaming" && (
        <div style={{ background: "#fff", borderRadius: 16, border: "1.5px solid #e5e7eb", padding: 20, marginBottom: 20, boxShadow: "0 1px 6px rgba(0,0,0,0.04)" }}>

          {/* Location — shared across Internet and Insurance */}
          {(cat === "internet" || cat === "insurance") && (
            <div style={{ marginBottom: 16 }}>
              <LocationInput zip={zip} city={city} onZipChange={v => { setZip(v); setCity(""); }} onLocationDetected={handleLocationDetected} />
            </div>
          )}

          {/* Internet */}
          {cat === "internet" && (
            <div style={fld}>
              <label style={lbl}>Speed I need</label>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {SPEED_OPTIONS.map(s => (
                  <button key={s} onClick={() => setSpeed(s)} style={{ padding: "8px 14px", borderRadius: 10, border: `1.5px solid ${speed === s ? "#2563eb" : "#e5e7eb"}`, background: speed === s ? "#eff6ff" : "#fff", color: speed === s ? "#1d4ed8" : "#374151", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
                    {s >= 1000 ? "1 Gbps" : `${s} Mbps`}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Mobile */}
          {cat === "mobile" && (
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <div style={fld}>
                <label style={lbl}>Number of lines</label>
                <select value={lines} onChange={e => setLines(+e.target.value)} style={{ ...inp, maxWidth: 200 }}>
                  {[1,2,3,4,5,6].map(n => <option key={n} value={n}>{n} line{n > 1 ? "s" : ""}</option>)}
                </select>
              </div>
              <div style={fld}>
                <label style={lbl}>Data needed per line</label>
                <div style={{ display: "flex", gap: 8 }}>
                  {DATA_OPTIONS.map(d => (
                    <button key={d} onClick={() => setData(d)} style={{ flex: 1, padding: "9px", borderRadius: 10, border: `1.5px solid ${data === d ? "#2563eb" : "#e5e7eb"}`, background: data === d ? "#eff6ff" : "#fff", color: data === d ? "#1d4ed8" : "#374151", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
                      {d}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Insurance */}
          {cat === "insurance" && (
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <div style={fld}>
                <label style={lbl}>Insurance type</label>
                <div style={{ display: "flex", gap: 8 }}>
                  {INSURANCE_TYPES.map(t => (
                    <button key={t} onClick={() => { setInsType(t); setCarYear(""); setCarMake(""); setCarModel(""); }} style={{ flex: 1, padding: "10px", borderRadius: 10, border: `1.5px solid ${insType === t ? "#2563eb" : "#e5e7eb"}`, background: insType === t ? "#eff6ff" : "#fff", color: insType === t ? "#1d4ed8" : "#374151", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                      {t}
                    </button>
                  ))}
                </div>
              </div>

              {/* Auto — Year → Make → Model cascading dropdowns */}
              {insType === "Auto" && (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
                  <div style={fld}>
                    <label style={lbl}>Year</label>
                    <select value={carYear} onChange={e => { setCarYear(e.target.value); setCarMake(""); setCarModel(""); }}
                      style={inp}>
                      <option value="">Select year</option>
                      {VEHICLE_YEARS.map(y => <option key={y} value={y}>{y}</option>)}
                    </select>
                  </div>
                  <div style={fld}>
                    <label style={lbl}>Make</label>
                    <select value={carMake} onChange={e => { setCarMake(e.target.value); setCarModel(""); }}
                      style={{ ...inp, color: carMake ? "#111" : "#9ca3af", opacity: carYear ? 1 : 0.5, cursor: carYear ? "pointer" : "not-allowed" }}
                      disabled={!carYear}>
                      <option value="">{carYear ? "Select make" : "Select year first"}</option>
                      {VEHICLE_MAKES.map(m => <option key={m} value={m}>{m}</option>)}
                    </select>
                  </div>
                  <div style={fld}>
                    <label style={lbl}>Model</label>
                    <select value={carModel} onChange={e => setCarModel(e.target.value)}
                      style={{ ...inp, color: carModel ? "#111" : "#9ca3af", opacity: carMake ? 1 : 0.5, cursor: carMake ? "pointer" : "not-allowed" }}
                      disabled={!carMake}>
                      <option value="">{carMake ? "Select model" : "Select make first"}</option>
                      {(VEHICLE_DATA[carMake] || []).map(m => <option key={m} value={m}>{m}</option>)}
                    </select>
                  </div>
                </div>
              )}

              {/* Home — Sq Ft + Year Built */}
              {insType === "Home" && (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                  <div style={fld}>
                    <label style={lbl}>Home size (sq ft)</label>
                    <input value={homeSqft} onChange={e => setHomeSqft(e.target.value)} placeholder="2000" style={inp} />
                  </div>
                  <div style={fld}>
                    <label style={lbl}>Year built</label>
                    <select value={homeYear} onChange={e => setHomeYear(e.target.value)} style={inp}>
                      <option value="">Select year</option>
                      {Array.from({length: 76}, (_, i) => String(2025 - i)).map(y => <option key={y} value={y}>{y}</option>)}
                    </select>
                  </div>
                </div>
              )}

              {/* Life / Renters — Age + Smoker */}
              {(insType === "Life" || insType === "Renters") && (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                  <div style={fld}>
                    <label style={lbl}>Your age</label>
                    <select value={personAge} onChange={e => setPersonAge(e.target.value)} style={inp}>
                      <option value="">Select age</option>
                      {Array.from({length: 62}, (_, i) => String(18 + i)).map(a => <option key={a} value={a}>{a}</option>)}
                    </select>
                  </div>
                  <div style={fld}>
                    <label style={lbl}>Smoker?</label>
                    <div style={{ display: "flex", gap: 8, paddingTop: 2 }}>
                      {["No", "Yes"].map(v => (
                        <button key={v} onClick={() => setSmoker(v)} style={{ flex: 1, padding: "10px", borderRadius: 10, border: `1.5px solid ${smoker === v ? "#2563eb" : "#e5e7eb"}`, background: smoker === v ? "#eff6ff" : "#fff", color: smoker === v ? "#1d4ed8" : "#374151", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                          {v}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              )}

            </div>
          )}

          <button onClick={search} disabled={loading} style={{ width: "100%", marginTop: 16, padding: 13, borderRadius: 12, border: "none", background: loading ? "#93c5fd" : "#1d4ed8", color: "#fff", fontSize: 15, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer" }}>
            {loading ? "Finding better rates..." : `Compare ${CATEGORIES.find(c => c.key === cat)?.label} Plans`}
          </button>
        </div>
      )}

      {error && <div style={{ background: "#fef2f2", border: "1.5px solid #fecaca", borderRadius: 12, padding: "14px 18px", marginBottom: 16, color: "#dc2626", fontSize: 14 }}>⚠️ {error}</div>}

      {results?.length > 0 && <>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>{results.length} providers found{city ? ` near ${city}` : zip ? ` for ${zip}` : ""}</div>
          <div style={{ fontSize: 12, color: "#9ca3af" }}>Click any result for details</div>
        </div>
        {cat === "internet"  && results.map((r, i) => <InternetCard  key={i} r={r} rank={i} />)}
        {cat === "mobile"    && results.map((r, i) => <MobileCard    key={i} r={r} rank={i} />)}
        {cat === "insurance" && results.map((r, i) => <InsuranceCard key={i} r={r} rank={i} />)}
        {cat === "insurance" && <div style={{ marginTop: 8, padding: "12px 16px", background: "#fffbeb", border: "1.5px solid #fde68a", borderRadius: 10, fontSize: 12, color: "#92400e", lineHeight: 1.6 }}>⚠️ Insurance rates are estimates only. Actual premiums depend on your personal information and coverage choices. Always get a formal quote before switching.</div>}
        {cat !== "insurance" && <div style={{ marginTop: 8, padding: "12px 16px", background: "#f8fafc", borderRadius: 10, fontSize: 11, color: "#9ca3af", lineHeight: 1.6 }}>💡 Prices are estimates based on typical rates in your area. MioPrice may earn a commission when you sign up through our links.</div>}
      </>}
    </div>
  );
}

// Note: File is complete above. The vs-average context is embedded in the AI prompt
// which now returns deal_label with context like "23% below avg" automatically.
